<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1821"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1825"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1835"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1833" /></clipPath></defs><g
     id="g1827"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1829"><g
         id="g1831"
         clip-path="url(#clipPath1835)"><g
           id="g1837"
           transform="translate(432.5537,230.2158)"><path
             d="m 0,0 c 5.095,18.414 7.817,37.813 7.817,57.849 0,119.534 -96.901,216.435 -216.435,216.435 -119.534,0 -216.436,-96.901 -216.436,-216.435 0,-119.535 96.902,-216.436 216.436,-216.436 4.96,0 9.881,0.167 14.758,0.496"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1839" /></g><g
           id="g1841"
           transform="translate(405.6621,256.7744)"><path
             d="m 0,0 c 1.739,10.17 2.645,20.624 2.645,31.29 0,101.825 -82.546,184.371 -184.372,184.371 -101.825,0 -184.371,-82.546 -184.371,-184.371 0,-101.825 82.546,-184.371 184.371,-184.371 11.74,0 23.223,1.097 34.353,3.195"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1843" /></g><g
           id="g1845"
           transform="translate(359.6968,217.1387)"><path
             d="m 0,0 -100.482,-174.04 c -9.135,-15.821 2.284,-35.599 20.553,-35.599 h 200.964 c 18.27,0 29.688,19.778 20.553,35.599 L 41.106,0 C 31.972,15.822 9.135,15.822 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1847" /></g><g
           id="g1849"
           transform="translate(380.0503,174.7144)"><path
             d="M 0,0 V -96.194"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1851" /></g><g
           id="g1853"
           transform="translate(380.0503,46.4561)"><path
             d="M 0,0 V 0"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1855" /></g><g
           id="g1857"
           transform="translate(239.9678,288.0645)"><path
             d="m 0,0 c 0,-8.854 -7.178,-16.032 -16.032,-16.032 -8.855,0 -16.032,7.178 -16.032,16.032 0,8.854 7.177,16.032 16.032,16.032 C -7.178,16.032 0,8.854 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1859" /></g><g
           id="g1861"
           transform="translate(239.9678,288.0645)"><path
             d="M 0,0 H 136.274"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1863" /></g><g
           id="g1865"
           transform="translate(210.2065,301.7935)"><path
             d="M 0,0 -90.481,90.481"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1867" /></g><g
           id="g1869"
           transform="translate(71.6289,288.0645)"><path
             d="M 0,0 H 16.032"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1871" /></g><g
           id="g1873"
           transform="translate(223.9355,440.3711)"><path
             d="M 0,0 V -16.032"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1875" /></g><g
           id="g1877"
           transform="translate(223.9355,151.7905)"><path
             d="M 0,0 V -16.032"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1879" /></g><g
           id="g1881"
           transform="translate(147.7822,156.1631)"><path
             d="M 0,0 4.008,6.942"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1883" /></g><g
           id="g1885"
           transform="translate(296.0806,413.0234)"><path
             d="M 0,0 4.008,6.942"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1887" /></g><g
           id="g1889"
           transform="translate(92.0342,364.2178)"><path
             d="M 0,0 6.942,-4.008"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1891" /></g><g
           id="g1893"
           transform="translate(151.7905,413.0234)"><path
             d="M 0,0 -4.008,6.942"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1895" /></g><g
           id="g1897"
           transform="translate(355.8369,364.2178)"><path
             d="M 0,0 -6.942,-4.008"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1899" /></g><g
           id="g1901"
           transform="translate(98.9766,215.9194)"><path
             d="M 0,0 -6.942,-4.008"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1903" /></g></g></g></g></svg>
</template>
